<div
    class="more-options"
    #trigger
    (click)="toggleDropdown(); $event.stopPropagation()"
>
  <mat-icon
      class="more-icon"
      svgIcon="more-options">
  </mat-icon>
</div>

<div
    *ngIf="isOpen"
    class="more-options-container"
    [style.top]="optionsTop"
>
    <div
        *ngFor="let option of options"
        class="options-item"
        [class.option-disabled]="option.disabled"
        (click)="onSelect(option); $event.stopPropagation()"
    >
        {{ option.string | translate }}
    </div>
</div>
